import React from "react";
import { connect } from "react-redux";

import { useMatch, useNavigate, useSearch } from "../utils/components/router";
import CustomerAddressForm from "../Customer/CustomerAddressForm";
import { kundenActions, kundenAdresseActions } from "../actions";
import { RAGE_RIGHT } from "../utils/enums";
import KundeLogin from "./KundeLogin";
import PageHeader from "./PageHeader";
import CONFIG from "../config";
import { checkResize, isAuthenticated } from "../utils/functions";

class KundenaddressEditMA extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.setAuthenticated = this.setAuthenticated.bind(this);
  }

  state = {
    data: [],
    authenticated: false,
    loading: false
  };

  componentDidMount() {
    const kundeAdressenListe = this.props.kundenAdresseStorage.kundeAdressen;
    if (!kundeAdressenListe.length && isAuthenticated(this.props)) {
      this.fetchAdresse();
    } else {
      this.setState({ data: kundeAdressenListe });
    }
    checkResize();
  }

  componentDidUpdate() {
    const kundeAdressenListe = this.props.kundenAdresseStorage.kundeAdressen;
    if (!kundeAdressenListe.length && !this.state.loading && isAuthenticated(this.props)) {
      this.fetchAdresse();
    }
  }

  fetchAdresse = async () => {
    if (this.state.loadin) return;
    this.setState({ loading: true });
    const kundenId = Number(this.props.params.id);
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde");
    requestDataKundenEntry.url = requestDataKundenEntry.url + kundenId;
    await this.props.dispatch(kundenActions.fetchEntry(requestDataKundenEntry));
    let kunde = this.props.kundenStorage.getKunde() || {};
    let kundeAdressen = kunde.listKundenAdressen || [];
    await this.props.dispatch(kundenAdresseActions.setAdressList(kundeAdressen));
    const kundeAdressenListe = this.props.kundenAdresseStorage.kundeAdressen || [];
    this.setState({ data: kundeAdressenListe, loading: false });
  };

  onSubmit = async formValues => {
    const id = Number(this.props.search.x);
    const kundenId = Number(this.props.params.id);
    let kundeAdressenListe = this.props.kundenAdresseStorage.kundeAdressen
      .map(kundeAdresse => {
        if (Number(kundeAdresse.id) === id) {
          return { ...formValues, id };
        } else {
          return kundeAdresse;
        }
      });
    let requestDataKundenEntry = this.props.configStorage.getRequestData("kunde", "post", {
      listKundenAdressen: kundeAdressenListe
    });
    requestDataKundenEntry.url = requestDataKundenEntry.url + kundenId;
    requestDataKundenEntry.url = requestDataKundenEntry.url + "/adresse";
    await this.props.dispatch(kundenAdresseActions.sendAdresse(requestDataKundenEntry));
    this.props.navigate(this.props.configStorage.getLinkPath("LINK_KUNDEN_ADDRESSE_MA", kundenId));
  };

  setAuthenticated() {
    this.setState({ authenticated: true });
  }

  render() {
    if (!this.state.authenticated && !isAuthenticated(this.props)) {
      return (<KundeLogin authenticated={this.setAuthenticated}></KundeLogin>);
    }
    let id = Number(this.props.search.x);
    let index = this.state.data.findIndex(x => Number(x.id) === id);
    if (!this.state.data[index] || this.state.loading) {
      return <div>Loading...</div>;
    }
    const kunde = this.props.kundenStorage.getKunde() || {};
    return (
      <div id={CONFIG.SHOP_ID} className="if6_outer section if6_section">
        <PageHeader showTimeout={true} />
        <section className="bootstrap-iso">
          <div className="container bg-white pt-one pb-one">
            <div className="">
              <div className=""></div>
              <div className="col-md-10 offset-md-2">
                <div className="align-self-center">
                  <h2 className="text-secondary">
                    Addresse aktualisieren
                  </h2>
                  <CustomerAddressForm
                    initialValues={{
                      name: this.state.data[index].name,
                      strasse: this.state.data[index].strasse,
                      strasse2: this.state.data[index].strasse2,
                      plz: this.state.data[index].plz,
                      ort: this.state.data[index].ort
                    }}
                    kundenVorname={kunde.vorname ? kunde.vorname : ""}
                    kundenNachname={kunde.nachname}
                    onSubmit={this.onSubmit}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default connect(store => {
  return {
    configStorage: store.configStorage,
    kundenStorage: store.kundenStorage,
    kundenAdresseStorage: store.kundenAdresseStorage,
    rightStorage: store.rightStorage,
    authenticationStorage: store.authenticationStorage,
    requiredRageRight: [RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI]
  };
})((props) => {
  const { params } = useMatch();
  const navigate = useNavigate();
  const search = useSearch();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <KundenaddressEditMA params={params} search={search} navigate={contextNavigate} {...props} />;
});
